import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getCustomFields, getCampaign as getParentCampaign } from "data/parent-campaign";
import { getSpreedlyToken } from "data/spreedly";

import { nextPage, previousPage } from "data/voting-form/routes";
import { submitVotingForm } from "data/voting-form/voting";

import Form from "./Form";

class DonateForm extends React.Component {
  handleCloseModal = () => {
    const { onCloseModal } = this.props;

    onCloseModal();
  };

  handleCustomSubmit = (values, dispatch) => {
    const { parentCampaign, nextPage, spreedlyToken } = this.props;

    return submitVotingForm(
      parentCampaign.get("id"),
      dispatch,
      values,
      spreedlyToken,
    ).then(() => {
      nextPage();
    });
  };

  render() {
    return (
      <section className="voting-modal primary-color-background">
        <div className="voting-modal-background">
          <button
            data-testid="t-voting-form--DonateF-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button secondary-color-text"
            onClick={this.handleCloseModal}>
            <i className="fa fa-times fa-2x"></i>
          </button>
          <div className="p-md-b">
            <h2 className="voting-modal-header">
              <span className="step-active secondary-color-text">Give</span> &gt; Vote
              &gt; Watch
            </h2>
            <span className="white-font-color">Enter your billing information.</span>
          </div>
          <Form
            data-testid="t-voting-form--DonateF-Form-2"
            onSubmit={this.handleCustomSubmit}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    parentCampaign: getParentCampaign(state)("voting_form"),
    spreedlyToken: getSpreedlyToken(state),
  };
};

const mapActionCreators = {
  nextPage,
};

export default connect(mapStateToProps, mapActionCreators)(DonateForm);
